import { MessageType } from "../types/page-extraction.types";

// Send message to iframe (client)
export function sendMessageToIframe(
  type: MessageType,
  data: any = {}
): boolean {
  const iframe = document.getElementById(
    "automation-embed-iframe"
  ) as HTMLIFrameElement;
  if (iframe && iframe.contentWindow) {
    const message = {
      type,
      data,
      timestamp: Date.now(),
      source: "widget",
    };

    // console.log("Widget sending message to iframe:", message);
    iframe.contentWindow.postMessage(message, "*");
    return true;
  }
  return false;
}

// Send message to parent window (host page)
export function sendMessageToParent(
  type: MessageType,
  data: any = {}
): boolean {
  if (window.parent && window.parent !== window) {
    const message = {
      type,
      data,
      timestamp: Date.now(),
      source: "widget",
    };

    // console.log("Widget sending message to parent:", message);
    window.parent.postMessage(message, "*");
    return true;
  }
  return false;
}
